import React from 'react';
import { CloudUploadIcon, UsersIcon, MonitorSmartphoneIcon, FileTextIcon, QuoteIcon } from 'lucide-react';
import { cityCard, REFERENCE_IMAGE } from '../../../data/richelieuProof';
type P = {
  isFR: boolean;
};
const POINT_ICONS = {
  deployed: CloudUploadIcon,
  field: UsersIcon,
  channels: MonitorSmartphoneIcon,
  tracking: FileTextIcon
} as const;

// The aerial photo + Ville de Richelieu logo come from the supplied visual (1536 × 1024).
// We crop that region (x 57–373, y 243–495) via background positioning.
const CROP = {
  x: 57,
  y: 243,
  w: 316,
  h: 252,
  W: 1536,
  H: 1024
};
export function RichelieuCard({
  isFR
}: P) {
  const pick = (v: {
    fr: string;
    en: string;
  }) => isFR ? v.fr : v.en;
  return <article className="rounded-2xl border border-[#E8E8F0] bg-white overflow-hidden shadow-[0_18px_40px_-30px_rgba(40,36,120,0.35)] h-full flex flex-col" data-id="element-6080" data-mp="ssslltrrs3da">
      <div className="relative w-full" style={{
      aspectRatio: `${CROP.w} / ${CROP.h}`,
      backgroundImage: `url("${REFERENCE_IMAGE}")`,
      backgroundSize: `${CROP.W / CROP.w * 100}% auto`,
      backgroundPosition: `${CROP.x / (CROP.W - CROP.w) * 100}% ${CROP.y / (CROP.H - CROP.h) * 100}%`,
      backgroundRepeat: 'no-repeat'
    }} role="img" aria-label={isFR ? 'Vue aérienne de la Ville de Richelieu' : 'Aerial view of the City of Richelieu'} data-id="element-6081" data-mp="16qh26pet0ocj">
        {/* Localized status pill, placed over the original badge area */}
        <span className="absolute flex items-center justify-center gap-1.5 rounded-full bg-[#F0F9F2] border border-[#D6EEDC] font-sans font-semibold text-[#1E8A45] uppercase whitespace-nowrap" style={{
        left: '53%',
        top: '2%',
        width: '43%',
        height: '13.5%',
        fontSize: 'clamp(9px, 0.72vw, 11.5px)',
        letterSpacing: '0.02em'
      }} data-id="element-6082" data-mp="2wa5g6ieu9e3u">
          <span className="w-2 h-2 rounded-full bg-[#22A559]" aria-hidden="true" data-id="element-6083" data-mp="3a2v5avpnyz56" />
          {pick(cityCard.status)}
        </span>
      </div>

      <div className="px-6 pt-6 pb-6 flex-1 flex flex-col" data-id="element-6084" data-mp="1eydixpwcbwkm">
        <h3 className="font-serif text-[1.55rem] text-[#121212] leading-tight" data-id="element-6085" data-mp="1eywzp3a98ex2">{pick(cityCard.name)}</h3>
        <p className="font-sans text-[15px] text-[#6B7180] leading-snug mt-2" data-id="element-6086" data-mp="1aymwfyduk2lw">{pick(cityCard.tagline)}</p>
        <ul className="mt-4 border-t border-[#EEEEF4] pt-4 space-y-3.5" data-id="element-6087" data-mp="1opi08w9hntim">
          {cityCard.points.map(pt => {
          const Icon = POINT_ICONS[pt.key as keyof typeof POINT_ICONS];
          return <li key={pt.key} className="flex items-start gap-3.5" data-id="element-6088" data-mp="1yo7g6jhtr3w8">
                <span className="w-9 h-9 rounded-full bg-[#F1F0FD] flex items-center justify-center shrink-0" aria-hidden="true" data-id="element-6089" data-mp="1tmruqqbqivdb">
                  <Icon className="w-[17px] h-[17px] text-[#4F46E5]" strokeWidth={1.7} data-id="element-6090" data-mp="27kosvr5u79u3" />
                </span>
                <span className="font-sans text-[13.5px] text-[#2A2F3C] leading-snug pt-1" data-id="element-6091" data-mp="d91rflsfwb4q">{pick(pt.text)}</span>
              </li>;
        })}
        </ul>
        <figure className="mt-6 rounded-xl bg-[#F6F5FD] px-5 py-5 lg:mt-auto" data-id="element-6092" data-mp="8brpj6nv6700">
          <QuoteIcon className="w-5 h-5 text-[#4F46E5] fill-[#4F46E5]" aria-hidden="true" data-id="element-6093" data-mp="2jylhstrdcsll" />
          <blockquote className="font-sans text-[15px] text-[#3A3F55] leading-relaxed mt-2" data-id="element-6094" data-mp="2ovc07nqnc0a6">{pick(cityCard.quote)}</blockquote>
          <figcaption className="font-sans text-[12px] text-[#6B7180] mt-3" data-id="element-6095" data-mp="2b4qe7q5wba82">{pick(cityCard.quoteBy)}</figcaption>
        </figure>
      </div>
    </article>;
}